<template>
    <div>
        <el-tree ref="menuTree" :data="treeList" show-checkbox node-key="menuId" @check="handleCheckChange" check-strictly :props="defaultProps"></el-tree>
        <div style="display: flex;align-items: center;justify-content: flex-end;margin-top: 20px;">
            <el-button size="small" @click="close()">取消</el-button>
            <el-button type="primary" size="small" @click="onSubmit">保存</el-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'terUserMenuAction',
    props: {
        menuData: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            treeList: [],
            userJurisdiction: [],
            defaultProps: {
                children: 'children',
                label: 'menuName',
            }
        }
    },
    methods: {
        async queryMenu() {
            const res = await this.$http.terminalMenuqueryBoundMenuIds({
                ids: [this.menuData.opmId]
            })
            if (res.status == 200) {
                this.userJurisdiction=res.result
                console.log(res);
                this.$nextTick(() => {
                    this.$refs.menuTree.setCheckedKeys([])
                    this.$refs.menuTree.setCheckedKeys(this.userJurisdiction)
                })
            } else {
                this.$message.error(res.message)
            }
        },
        close() {
            this.$emit('close',false)
        },
        async onSubmit() {
            const res = await this.$http.terminalMenubindMenus({
                menuIds: this.userJurisdiction,
                opmId: this.menuData.opmId
            })
            if (res.status == 200) {
                this.$emit('close',true)
                this.$message.success(res.message)
            } else {
                this.$message.error(res.message)
            }
        },
        handleCheckChange(currentObj, treeStatus) {
            this.userJurisdiction = treeStatus.checkedKeys
        },
    },
    created() {
        this.queryMenu()
    },
    mounted() {

    },
}
</script>

<style>
</style>